module.exports = __webpack_public_path__ + "static/media/bottom-right@2x.1555b6b8.png";